"use client";

import { Box } from "@mui/material";
import VideoStream from "@v2/components/VideoStream";

interface VideoLCSettingsType {
    label?: string | null,
    full_width?: boolean,
    max_width?: string,
    ratio?: string,
}

interface VideoLCDataType {
    id?: number,
    slug: string,
    title?: string,
    poster?: string | null,
}

const DEFAULT_RATIO = "16 / 9";

function normalizeRatio(ratio?: string | null) {
    if (!ratio) return DEFAULT_RATIO;
    const clean = ratio.toString().trim().replace(/\s*\/\s*/g, " / ");
    return /^\d+(\.\d+)?\s*\/\s*\d+(\.\d+)?$/.test(clean) ? clean : DEFAULT_RATIO;
}

export default function VideoLC({ content }: {
    content: {
        data: VideoLCDataType,
        settings?: VideoLCSettingsType
    };
}) {
    if (!content.data?.slug) return null;

    const ratio = normalizeRatio(content.settings?.ratio);

    return (
        <Box sx={{
            maxWidth: content.settings?.full_width ? 'none' : 1400,
            margin: 'auto',
            userSelect: 'none',
            ...(content.settings?.max_width && { maxWidth: `${content.settings.max_width}px` }),
        }}>
            <VideoStream
                slug={content.data.slug}
                title={content.data.title}
                ratio={ratio}
                poster={content.data.poster ?? null}
            />
        </Box>
    )
}
